import { useDraggable } from "@dnd-kit/core";
import { FC, PropsWithChildren, useMemo } from "react";

import { TDragRideData } from "@ryde/shared";

import { DraggableActivatorContext } from "./draggable.activator.context";

export interface IDraggableWrapper extends PropsWithChildren {
  id: string;
  disabled?: boolean;
  element?: "div" | "p" | "span" | "ul" | "tr" | "td";
  dragData?: TDragRideData;
  className?: string;
  isListeners?: boolean;
}

export const DraggableWrapper: FC<IDraggableWrapper> = ({
  children,
  element,
  className,
  dragData,
  id,
  disabled,
  isListeners = true,
}) => {
  const Element = element || "div";
  const { attributes, listeners, setNodeRef, setActivatorNodeRef } =
    useDraggable({
      id,
      data: { ...dragData },
      disabled,
    });

  const parsedListeners = isListeners ? listeners : {};

  const activatorContextValue = useMemo(
    () =>
      isListeners
        ? null
        : {
            listeners,
            setActivatorNodeRef,
          },
    [isListeners, listeners, setActivatorNodeRef],
  );

  const wrappedChildren = activatorContextValue ? (
    <DraggableActivatorContext.Provider value={activatorContextValue}>
      {children}
    </DraggableActivatorContext.Provider>
  ) : (
    children
  );

  return (
    <Element
      ref={setNodeRef}
      {...parsedListeners}
      {...attributes}
      className={className}
    >
      {wrappedChildren}
    </Element>
  );
};
